import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.css";
import SignInContainer from "../../components/containers/SignInContainer";
import { Row, Col, Card, Input, Button } from "antd";
import { AuthAction } from "../../store/actions";
import { FaUserCircle } from "react-icons/fa";
import BlackImage from "../../assets/images/black.jpg";
import CustomModal from "../../components/modals/customModal";
import Profile_success from "../../assets/images/profile_success.png";
import LosisticLogo from "../../assets/images/contractor-logo.png";
import KeyIcon from "../../assets/images/key.png";
import KeyIconOver from "../../assets/images/keyOver.png";
import { GrKey } from "react-icons/gr";
class NewPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
      redirect_uri: "",
      isOpen: false,
      verification_code: ''
    };
  }

  componentDidMount() {
    this.setState({
      verification_code: this.props?.location?.search?.split('?')?.[1]
    })

  }


  onHandleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [`${e.target.name}Error`]: "",
      errorReducer: "",
    });
  };
  onSubmit = () => {
    const { email, password, password_confirmation, passwordError, password_confirmationError, verification_code } = this.state;
    console.log("Email===>", password.length < 8);
    let useUri = email.split("@");
    console.log("Emailsss===>", useUri[0])
    if (!password.trim().length || password.length < 8 || !password_confirmation?.trim()?.length ||
      password?.trim()?.length && password_confirmation !== password
    ) {
      if (!password.trim().length) {
        this.setState({
          passwordError: "New password is required",
        });
      }
      if (!!password.length && password.length < 8) {
        this.setState({
          passwordError: "password should be at least 8 characters long",
        });
      }
      if (!password_confirmation.trim().length) {
        this.setState({
          password_confirmationError: "Confirm password is required",
        });
      }
      if (password.trim().length && password_confirmation.length !== password) {
        this.setState({
          password_confirmationError: "password mismatch",
        })
      }
      return;
    }
    this.props.ForgotPassword({ password, password_confirmation, verification_code }, () =>
      this.props.history.push('/signin')
    );
  };
  // onSubmit = () => {
  //   const { email, redirect_uri } = this.state;
  //   console.log("Email===>", email);
  //   let useUri = email.split("@");
  //   console.log("Emailsss===>", useUri[0]);
  //   // this.setState({
  //   //   redirect_uri: useUri[0],
  //   // });
  //   if (!email.length) {
  //     if (!email.length) {
  //       this.setState({
  //         emailError: "Email required",
  //       });
  //     }
  //     return;
  //   }
  //   this.props.ResetPassword({ email, redirect_uri: useUri[0] }, () =>
  //     this.setState({
  //       isOpen: true,
  //     })
  //   );
  // };
  componentDidUpdate(preProps, PreState) {
    if (preProps.error !== this.props.error && !this.props.loader) {
      this.setState({
        errorReducer: "Oops, thats not a match",
      });
    }
  }

  render() {
    const { signin, loader, error } = this.props;
    const { emailError, isOpen } = this.state;
    return (
      <SignInContainer>
        <Row justify="center">
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row justify="center" gutter={[0, 40]} align="middle">
              <Col
                xl={15}
                xs={22}
                sm={22}
                md={20}
                lg={20}
                style={{ marginTop: "10rem" }}
              >
                <Card style={{ width: "100%" }}>
                  <Row gutter={[0, 15]} style={{ position: "relative" }}>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      style={{
                        height: "155px",
                        width: "155px",
                        borderRadius: "50%",
                        backgroundSize: "contain",
                        backgroundImage: `url(${LosisticLogo})`,
                        position: "absolute",
                        top: "-90px",
                        right: 0,
                        left: "25%",
                        backgroundRepeat:'no-repeat'
                      }}
                    ></Col>
                    <Col span={24} style={{ marginTop: "120px" }}>
                      <Row gutter={[0, 15]} justify="center">
                        <Col span={20}>
                          <Input
                            style={{
                              borderBottom: "1px solid gray",
                              padding: "15px",
                            }}
                            type="password"
                            bordered={false}
                            size="25"
                            placeholder="NEW PASSWORD"
                            name="password"
                            onMouseOver={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: true,
                              });
                            }}
                            onMouseOut={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: false,
                              });
                            }}
                            onChange={this.onHandleChange}
                            prefix={
                              <img
                                src={
                                  !this.state["password_onHover"] ?
                                    KeyIcon
                                    :
                                    KeyIconOver
                                } />
                            }
                          />
                          <Input
                            style={{
                              borderBottom: "1px solid gray",
                              padding: "15px",
                            }}
                            type="password"
                            bordered={false}
                            size="25"
                            placeholder="CONFRIM PASSWORD"
                            name="password_confirmation"
                            onMouseOver={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: true,
                              });
                            }}
                            onMouseOut={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: false,
                              });
                            }}
                            onChange={this.onHandleChange}
                            prefix={
                              <img
                                src={
                                  !this.state["password_confirmation_onHover"] ?
                                    KeyIcon
                                    :
                                    KeyIconOver
                                } />
                            }
                          />

                          <Row>
                            <Col span={24}>
                              <span className="text-right d-grid danger-color">
                                {emailError && emailError}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Col style={{ marginTop: "20px" }}>
                        <Button
                          style={{
                            backgroundColor: "#ff9800",
                            color: "#fff",
                            width: "50%",
                          }}
                          onClick={this.onSubmit}
                        >
                          SUBMIT
                        </Button>
                      </Col>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        <CustomModal
          visible={isOpen}
          onCancelModal={() =>
            this.setState({
              isOpen: false,
            })
          }
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.setState({ isOpen: false })}
                >
                  Ok
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <img src={Profile_success} />
            </Col>
            <Col span={18} style={{ textAlign: "center" }}>
              <span>
                An email with instructions has been sent to your inbox
              </span>
            </Col>
          </Row>
        </CustomModal>
      </SignInContainer>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
    error: storeState?.AuthReducer.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ForgotPassword: (payload, cb) => {
      dispatch(AuthAction.ForgotPassword(payload, cb))
    },
    socialSignIn: (payload, cb) => {
      dispatch(AuthAction.SocialSignInReq(payload, cb));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewPassword);
